import { Box, Flex } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import React, { Suspense, useMemo } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { SplashScreen } from "../../components/Loader";
import Sidebar from "../../components/Sidebar";
import { MenuConstants } from "../../constants/menu";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import ChangePassword from "./change-password";

const DelayImport = (path) => {
  return React.lazy(() => {
    return Promise.all([path, new Promise((resolve) => setTimeout(resolve, 300))]).then(([moduleExports]) => moduleExports);
  });
};

//Dashboard
const Dashboard = DelayImport(import("./dashboard"));
const Attendance1 = DelayImport(import("./attendance"));
const LeaveRequest1 = DelayImport(import("./leave-request"));
const Announcement = DelayImport(import("./announcement"));

// Report
const AttendanceReport = DelayImport(import("./report/attendance/list"));
const LeaveRequestReport = DelayImport(import("../app/report/leave-request"));

//setting
const Employee = DelayImport(import("./employee"));
const Position = DelayImport(import("./position"));
const Department = DelayImport(import("./department"));
const WorkingLocation = DelayImport(import("./working-location"));
const User = DelayImport(import("./user"));
const WorkShift = DelayImport(import("./work-shift"));
const TelegramNotification = DelayImport(import("./telegram-notification"));
const SystemRole = DelayImport(import("./system-role"));

const routeItem = [
  // Dashboard Menu
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/attendance", component: <Attendance1 /> },
  { path: "/leave-request", component: <LeaveRequest1 /> },
  { path: "/announcement", component: <Announcement /> },

  // Report Menu
  { path: "/attendance-report", component: <AttendanceReport /> },
  { path: "/leave-request-report", component: <LeaveRequestReport /> },

  // Setting Menu
  { path: "/employee", component: <Employee /> },
  { path: "/position", component: <Position /> },
  { path: "/department", component: <Department /> },
  { path: "/working-location", component: <WorkingLocation /> },
  { path: "/user", component: <User /> },
  { path: "/work-shift", component: <WorkShift /> },
  { path: "/telegram-notification", component: <TelegramNotification /> },
  { path: "/system-role", component: <SystemRole /> },
  { path: "/change-password", component: <ChangePassword /> },
];

const MotionBox = motion(Box);
export default function App() {
  const { user } = useAuth();
  const username = user.username;
  const location = useLocation();
  const redirectURL = useMemo(() => {
    if (user.menuPermission) {
      return MenuConstants.reduce((acc, { item }) => [...acc, ...item], []).find(({ id }) => user.menuPermission[id] && user.menuPermission[id]["VIEW"])?.id;
    }
  }, [user.menuPermission]);

  return (
    <Flex position="relative" h="100vh" overflow="auto" id="app-container">
      <Box display="flex" /* hidden={user?.statusLogin === 1} */>
        <Sidebar />
      </Box>
      <Box w={"calc(100% - 18rem)"} p="2" position="relative" flex="1">
        <Suspense fallback={<SplashScreen />}>
          <AnimatePresence exitBeforeEnter>
            <Switch location={location} key={location.pathname}>
              {routeItem.map(({ path, component }) => {
                if (path === "/change-password" && username === "super_admin") {
                  return <Redirect to="/" />;
                }
                return (
                  <Route key={path} path={path}>
                    <MotionBox
                      h="full"
                      overflow="auto"
                      rounded="md"
                      key={location.pathname}
                      initial={{
                        y: -10,
                        opacity: 0,
                        transition: { duration: 0.15 },
                      }}
                      animate={{
                        y: 0,
                        opacity: 1,
                        transition: { duration: 0.2 },
                      }}
                      exit={{
                        y: -20,
                        opacity: 0,
                        transition: { duration: 0.15 },
                      }}
                    >
                      {component}
                    </MotionBox>
                  </Route>
                );
              })}
              {!!redirectURL ? <Redirect to={`/${redirectURL}`} /> : <Redirect to={`/`} />}
            </Switch>
          </AnimatePresence>
        </Suspense>
      </Box>
    </Flex>
  );
}
